﻿document.addEventListener("DOMContentLoaded", function ()
{
    setCustomerServiceAvailability();    
});

function setCustomerServiceAvailability()
{
    const currentDate = new Date();
    const hour = currentDate.getHours();
    if (hour >= 9 && hour <= 21)
        $(".c-customerservice__phone-status").addClass("c-customerservice__phone-available");
    else
        $(".c-customerservice__phone-status").addClass("c-customerservice__phone-unavailable");
}